import React, { useEffect, useState, useRef } from "react";
import { useSelector } from 'react-redux';
import { Chart } from "react-google-charts";
import TapSelect from "../../../components/ui/TapSelect";
import HttpAPICall from '../../../services/HttpAPICall';
import tapIcon from "../../../services/TapIcon";
import moment from "moment";
import UpdateMyDashboardForm from "../../settings/configurationGeneral/myDashboard/UpdateMyDashboardForm";
import Loader from "../../../components/ui/Loader/Loader";
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import DateService from "../../../services/DateService";
import { Link } from "react-router-dom";
import TapHelper from "../../../services/TapHelper";

const PoPurLeadTimeAgingWidget = (props) => {
    
    const widgetUrl             =   INVENTORY_API_BASE_URL_2 + "/report/item_wise_po_pur_lead_time_widget";
    const updateMyDashboardRef  =   useRef();
    const access_token          =   useSelector(state => state.auth.access_token);
    const allWarehouses         =   useSelector(state => state.app.warehouses ? state.app.warehouses   : []);
    const widget_keys           =   useSelector(state => state.app.user_info?.widget_keys || []);

    const [widgetData, setWidgetData]   =   useState(null) 
    const [formData, setFormData]   =   useState({
        warehouses  :   [],
        userFilters :   [
            {value  :   'tagged_me',    label : 'My Tagged PO'},
            {value  :   'created_by_me',    label : 'PO Created By Me'},
        ],
        filterData  :   {
            canChange           :   false,
            search_warehouse_id :   "",
            tagged_user_filter  :   ""
        }
    })

    const [agingData, setAgingData] = useState({
        loading         :   false,
        data            :   [],
        status_ids      :   [],
        remark_time     :   '',
    });
    const [reload, setReload] = useState(false);

    const [linkParrams, setLinkParms] = useState({});


    useEffect(() => {
        setAgingData(pre => ({...pre, loading: true}));
        initializeFormFilter();
        if (reload) {
            leadTimeAgingData();
        } else if (formData.filterData.canChange) {
            leadTimeAgingData();
        } else {
            if (localStorage.getItem('poLeadTimeAgeingWidget')) {

                let leadData = JSON.parse(localStorage.getItem('poLeadTimeAgeingWidget'));
                if (leadData) {

                    let differenceInSeconds = DateService.differenceInSeconds(moment(leadData.time, 'DD-MM-YYYY HH:mm A').format());
                    if (differenceInSeconds > 86400) {
                        localStorage.removeItem('poLeadTimeAgeingWidget')
                        setTimeout(() => {
                            leadTimeAgingData();
                        }, 1000 * (props.indexProps || 12));

                    } else {
                        setAgingData(pre => ({
                            ...pre,
                            data: leadData.data,
                            loading:false,
                            remark_time: leadData.time,
                        }))
                    }
                } else {
                    setTimeout(() => {
                        leadTimeAgingData();
                    }, 1000 * (props.indexProps || 12));
                }
            } else {
                setTimeout(() => {
                    leadTimeAgingData();
                }, 1000 * (props.indexProps || 12));
            }
        }     

        let params          =   {};
        if(formData.filterData.search_warehouse_id) {
            params          =   {...params, search_warehouse_id : formData.filterData.search_warehouse_id};
        }
        if(formData.filterData.tagged_user_filter) {
            params          =   {...params, tagged_user_filter : formData.filterData.tagged_user_filter};
        }
        params          =   {...params, search_status_ids : JSON.stringify(agingData.status_ids)};
        setLinkParms(params);

    }, [formData.filterData, reload]);
    const initializeFormFilter = () => {
       setFormData(pre => ({
            ...pre,
            warehouses : allWarehouses.map(w => ({value: w.id, label: `${w.name} (${w.code})`})) 
        }))
        setWidgetData(widget_keys.length > 0 && widget_keys.find(st => {return("isc_purchase_order_lead_time_ageing" == st.key)}) ? widget_keys.find(st => {return(st.key == "isc_purchase_order_lead_time_ageing")})  : null)
    };

    const leadTimeAgingData =   ()  =>  {
        setAgingData(pre => ({...pre, loading: true}));
        
        let params          =   {...formData.filterData, reload : reload ? 'reload' : false};
        HttpAPICall.withAthorization('GET', widgetUrl, access_token, params, {} , (response) => {
            const res = response.data;
            setAgingData(pre => ({
                ...pre, 
                data    :   res.data,
                status_ids : res.status_ids,
                remark_time :   res.time
            }));
            setLinkParms(pre => ({...pre, search_status_ids : JSON.stringify(res.status_ids)}));
            if(!formData.filterData.search_warehouse_id && !formData.filterData.tagged_user_filter){
                localStorage.setItem('poLeadTimeAgeingWidget',JSON.stringify(res));
            }
            if(reload !== false){
                localStorage.setItem('poLeadTimeAgeingWidget',JSON.stringify(res));
            }
        }).then(() => {
            setAgingData(pre => ({...pre, loading: false}))
            setReload(false)
            setFormData(pre => ({...pre, canChange : false}))
        });
    }

    const pinMyDashboardHandler = (widgetData = null) => {
        updateMyDashboardRef.current.updateMyDashboardModalInit(widgetData, { key: "isc_purchase_order_lead_time_ageing", name: "Po Purchase Lead Time Ageing" });
    };

    // const tapSelectChange = (selectedOption, formKey, fieldKey) => {
    //     setAgingData((prevState) => ({
    //         ...prevState,
    //         [formKey]: {
    //             ...prevState[formKey],
    //             [fieldKey]: selectedOption ? selectedOption.value : ''
    //         }
    //     }));
    // };
    return (
        <div className="card mt-3">
            <div className="card-body">
                <div className="row">
                    <div className="col-5">
                        <h6 className="fw-bold primary_color">PO Purchase Lead Time Ageing</h6>
                    </div> 
                    <div className="col-3">
                        <TapSelect
                            options={formData.userFilters}
                            changeEvent={(selectedOption) => {
                                setFormData(pre => ({
                                    ...pre, 
                                    filterData : {
                                        ...formData.filterData,
                                        canChange : true,
                                        tagged_user_filter : selectedOption ? selectedOption.value : ""
                                    }
                                }))
                            }}
                            value={formData.userFilters.find(u => u.value == formData.filterData.tagged_user_filter)}
                            isSearchable={true}
                            isClearable={true}
                            containerHeight="33px"
                            fontSize="93%"
                            width="99%"
                            placeholder="All PO"
                        />
                    </div>
                    <div className="col-3 p0">
                        <TapSelect
                            options={formData.warehouses}
                            changeEvent={(selectedOption) => {
                                setFormData(pre => ({
                                    ...pre, 
                                    filterData : {
                                        ...formData.filterData,
                                        canChange : true,
                                        search_warehouse_id : selectedOption ? selectedOption.value : ""
                                    }
                                }))
                            }}
                            value={formData.warehouses.find(u => u.value == formData.filterData.search_warehouse_id)}
                            isSearchable={true}
                            isClearable={true}
                            containerHeight="33px"
                            fontSize="93%"
                            width="99%"
                            placeholder="All Warehouses"
                        />
                    </div>
                    <div className="col-1 px-0 mx-0 text-center">
                        <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-2 btn btn-light btn-block" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                        <ul className="dropdown-menu dropdown-menu-end">
                            <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => setReload(true)}>Refresh</li>
                            <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => pinMyDashboardHandler(widgetData)}>{!widgetData ? "Pinned to My Dashboard" : "Unpinned from My Dashboard"}</li>
                        </ul>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-6">
                        <table className="table table-hover table-bordered table-borderless bg-white">
                            <thead className="table-secondary">
                                <tr className="text-center">
                                    <th style={{ width: "50%" }} className="text-start" >Ageing in Days</th>
                                    <th style={{ width: "25%" }}>No. of Line Item</th>
                                    <th style={{ width: "25%" }}>No. of Item Qty</th>
                                </tr>
                            </thead>
                            <tbody>
                                {agingData.loading 
                                ? <tr> <td className="text-center" colSpan="3"><Loader /></td></tr>
                                : 
                                agingData.data.length > 0 
                                ?
                                agingData.data.map((d) => (
                                    <tr key={d.display}>
                                        <td>{d.display}</td>
                                        <td className="text-end"><Link target='_blank' to={{ pathname: `/report/item_wise_po_purchase_analysis_report`, search: "?" + new URLSearchParams({
                                            [d.type] : d.value,
                                            ...linkParrams
                                        }).toString() 
                                            
                                            }}>{d.no_of_line_item}</Link></td>
                                        <td className="text-end">
                                            <Link target='_blank' to={{ pathname: `/report/item_wise_po_purchase_analysis_report`, search: "?" + new URLSearchParams({
                                                [d.type] : d.value,
                                                ...linkParrams
                                                }).toString() 
                                            }}>
                                            {d.qty && TapHelper.numberFormatter(Number(d.qty), 2)}
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                                :
                                <tr> <td className="text-center" colSpan="3">No Record Found</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="col-6 p0 mt-3 mb-1">
                        {agingData.loading
                        ? <Loader />
                        : 
                        <Chart
                            width={'100%'}
                            height={'100%'}
                            chartType="BarChart"
                            loader={`<div>Loading Chart</div>`}
                            data={[['Status', 'Quantity'], ...agingData.data?.map((d) => { return [d.display, TapHelper.numberFormatter(Number(d.qty))]; })]}
                            options={{
                                legend: { position: 'top' },
                                colors: ['#53a8e3'],
                                isStacked: true,
                                chartArea: { width: '100%', left: '80', height: '100%' }
                            }}
                            rootProps={{ 'data-testid': '1.5' }}
                        />
                        }
                    </div>
                </div>
                <div className="col-sm-12 text-muted fs11">
                    Report as of {agingData.remark_time}
                </div>
            </div>
            <UpdateMyDashboardForm ref={updateMyDashboardRef} />
        </div>
    );
};

export default PoPurLeadTimeAgingWidget;
